export default {
  total_orders: {
    title: 'Orders',
    orders: 'Orders:',
    sales_volume: 'Sales volume:',
    delivery_costs: 'Delivery costs:',
  },
  cash_orders: {
    title: 'Payment in cash/ at the door',
    orders: 'Orders:',
    sales_volume: 'Sales volume:',
    delivery_costs: 'Delivery costs:',
  },
  online_orders: {
    title: 'Online payments',
    orders: 'Orders:',
    sales_volume: 'Sales volume:',
    delivery_costs: 'Delivery costs:',
  },
  total: 'Total',
  collected_taxes_list: {
    title: {
      online: 'Online payment',
      cash: 'Cash payment',
    },
    table: {
      products_breakdown: {
        fields: {
          product: 'Product',
          quantity: 'Quantity',
          total: 'Total',
        },
        labels: {
          total_refunded: 'Refunded',
        },
      },
      tax_breakdown: {
        fields: {
          tax_percentage: 'Tax %',
          product_type: 'Type',
          netto: 'Net',
          tax: 'Tax',
          brutto: 'Total',
        },
        product_types: {
          product: 'Products {{percentage}}%',
          order_method_fee: 'Delivery fees {{percentage}}%',
          customer_service_fee: 'Online surcharge',
        },
      },
    },
  },
};
